export default "__VITE_ASSET__aMe1ji_3__"